import { useQuery } from "@tanstack/react-query";

import { CosignatureStatusEnum } from "@/core/constants";
import type {
  CosignatureStatusParam,
  GetCosignQueueResponse,
} from "@/core/types/(api)/cosignature";

import { optionFactory as cosignatureQueueOptionFactory } from "./useCosignatureQueue";

export const DEFAULT_NEEDS_REVIEW_STATUS =
  `${CosignatureStatusEnum.PENDING},${CosignatureStatusEnum.RESUBMITTED}` as CosignatureStatusParam;

type UseNeedsReviewQueueProps<TData = GetCosignQueueResponse> = {
  cosignature_status?: CosignatureStatusParam;
  enabled?: boolean;
  page_size?: number;
  select?: (data: GetCosignQueueResponse) => TData;
  start_key?: string;
  supervisor_id?: string;
};

function optionFactory(
  {
    cosignature_status,
    page_size,
    start_key,
    supervisor_id,
  }: Omit<UseNeedsReviewQueueProps, "select" | "enabled"> = {},
  enabled = true,
) {
  return cosignatureQueueOptionFactory(
    {
      cosignature_status: cosignature_status ?? DEFAULT_NEEDS_REVIEW_STATUS,
      page_size,
      start_key,
      supervisor_id,
    },
    enabled,
  );
}

export function useNeedsReviewQueue<TData = GetCosignQueueResponse>({
  cosignature_status,
  enabled,
  page_size,
  select,
  start_key,
  supervisor_id,
}: UseNeedsReviewQueueProps<TData> = {}) {
  return useQuery({
    ...optionFactory({ cosignature_status, page_size, start_key, supervisor_id }, enabled),
    keepPreviousData: true,
    select,
  });
}
